import React from "react";
import cn from "classnames";
import styles from "./NavbarToggle.module.scss";

interface NavbarToggleProps {
    className?: string;
    isOpen: boolean;  // Добавляем isOpen как пропс
    onClick: () => void;
}

const NavbarToggle: React.FC<NavbarToggleProps> = ({className = '', isOpen, onClick}) => {
    return (
        <div
            onClick={onClick}
            className={cn(styles.navbarToggle, {[styles.open]: isOpen}, className)}
        >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    );
}

export default NavbarToggle;
